import { useState, useEffect } from 'react'
import { useQuery } from '@tanstack/react-query'
import { getReports } from 'services/nobo'

const defaultPagination = {
  itemCount: 0,
  pageSize: 25,
  pageOffset: 0,
  page: 0,
}

const defaultFilters = {
  customerId: null,
}

function useReports() {
  const [pagination, setPagination] = useState(defaultPagination)
  const [filters, setFilters] = useState(defaultFilters)

  const { isLoading, data: reports } = useQuery({
    queryKey: ['getNoboReports', pagination.pageSize, pagination.pageOffset, filters.customerId],
    queryFn: () =>
      getReports({
        customerId: filters.customerId,
        pageSize: pagination.pageSize,
        pageOffset: pagination.pageOffset,
      }),
    refetchOnWindowFocus: false,
    throwOnError: true,
  })

  const itemCount = reports?.meta?.itemCount

  useEffect(() => {
    if (itemCount === undefined) {
      return
    }

    setPagination(prevState => ({
      ...prevState,
      itemCount,
    }))
  }, [itemCount])

  const handlePageChange = newPage => {
    const { page, pageSize } = pagination

    if (newPage === page) {
      return
    }

    const updatingPage = newPage > page ? page + 1 : page - 1

    setPagination(prevState => ({
      ...prevState,
      page: updatingPage,
      pageOffset: updatingPage * pageSize,
    }))
  }

  const handleRowsChange = pageSize => {
    setPagination(prevState => ({ ...prevState, page: 0, pageSize: pageSize, pageOffset: 0 }))
  }

  async function handleCustomerSearch(customer) {
    setFilters(prevState => ({
      ...prevState,
      customerId: customer?.id,
      customerSearch: customer,
    }))
  }

  return {
    reports: reports?.data || [],
    isLoading,
    filters,
    pagination,
    handleCustomerSearch,
    handlePageChange,
    handleRowsChange,
  }
}

export default useReports
